import React, { useState, useEffect } from "react";

import HelpSpinners from "components/spinners";
import { Grid, _ } from "gridjs-react";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import ModalRegistro from "components/admin/modal/registroLider";

const Lider = () => {
  const [loading, setLoading] = useState(true);
  const [show, setShow] = useState(false);

  const [tabla, setTabla] = useState([]);
  const handleClose = () => setShow(false);

  const tablaF = async () => {
    const res = await fetch(`${process.env.REACT_APP_SERVER_URL}/lider.php`);
    const data = await res.json();
    setTabla(data);

    setLoading(false);
  };


  const History = useNavigate();

  const Deletelink = async (data) => {
    const alert = await Swal.fire({
      title: "Desea eliminar esto ?",
      text: data,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, Eliminar",
    });
    if (alert.isConfirmed) {
      const data1 = await fetch(
        `${process.env.REACT_APP_SERVER_URL}/lider.php`,
        {
          method: "DELETE",
          body: data,
        }
      );
      const res = await data1.json();

      if (res.status === "ok") {
        Swal.fire({
          title: "",
          icon: "success",
          timer: 2000,
          toast: true,
          position: "top-end",
          width: "10rem",
          showConfirmButton: false,
        });
        tablaF();
      } else {
        Swal.fire("No se pudo eliminar");
      }
    } else {
      Swal.fire("-");
    }
  };

  const imprimirTodosLosPDFs = async () => {
    if (tabla.length === 0) {
      Swal.fire({
        title: "No hay datos",
        text: "No hay líderes para imprimir",
        icon: "warning",
      });
      return;
    }

    // Confirmar antes de descargar múltiples archivos
    const result = await Swal.fire({
      title: "¿Descargar todos los PDFs?",
      text: `Se descargarán ${tabla.length} PDFs`,
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sí, descargar todos",
      cancelButtonText: "Cancelar",
    });

    if (result.isConfirmed) {
      // Mostrar mensaje de progreso
      Swal.fire({
        title: "Descargando",
        text: `Descargando ${tabla.length} PDFs...`,
        icon: "info",
        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      // Descargar cada PDF
      for (let index = 0; index < tabla.length; index++) {
        const lider = tabla[index];
        try {
          const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/reportes/index.php?id=${lider.id_lider}`
          );
          
          if (!response.ok) {
            throw new Error(`Error al descargar PDF del líder ${lider.id_lider}`);
          }

          const blob = await response.blob();
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.download = `reporte_lider_${lider.id_lider}_${lider.nombreLider}_${lider.apellidoLider}.pdf`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);

          // Pequeño delay entre descargas
          if (index < tabla.length - 1) {
            await new Promise((resolve) => setTimeout(resolve, 500));
          }
        } catch (error) {
          console.error(`Error descargando PDF del líder ${lider.id_lider}:`, error);
        }
      }

      Swal.fire({
        title: "Completado",
        text: `Se han descargado ${tabla.length} PDFs`,
        icon: "success",
        timer: 2000,
        toast: true,
        position: "top-end",
      });
    }
  };

  useEffect(() => {
    tablaF();
    // eslint-disable-next-line
  }, []);

  return (
    <div className="" style={{ height: "100vh", marginTop: "5%" }}>
      {loading ? (
        <div className="carga">
          <HelpSpinners loading={loading} size={300} />
        </div>
      ) : (
        <>
          <div className="container text-center mb-4">
            <div className="row justify-content-md-end ">
              <div
                className=" col-4 btn-group "
                role="group"
                aria-label="Basic example"
              >
                <button
                  type="button"
                  onClick={() => setShow(true)}
                  className="btn btn-primary"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="30"
                    height="30"
                    fill="currentColor"
                    class="bi bi-person-add"
                    viewBox="0 0 16 16"
                  >
                    <path d="M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm.5-5v1h1a.5.5 0 0 1 0 1h-1v1a.5.5 0 0 1-1 0v-1h-1a.5.5 0 0 1 0-1h1v-1a.5.5 0 0 1 1 0Zm-2-6a3 3 0 1 1-6 0 3 3 0 0 1 6 0ZM8 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z" />
                    <path d="M8.256 14a4.474 4.474 0 0 1-.229-1.004H3c.001-.246.154-.986.832-1.664C4.484 10.68 5.711 10 8 10c.26 0 .507.009.74.025.226-.341.496-.65.804-.918C9.077 9.038 8.564 9 8 9c-5 0-6 3-6 4s1 1 1 1h5.256Z" />
                  </svg>
                </button>
                <button
                  type="button"
                  onClick={imprimirTodosLosPDFs}
                  className="btn btn-success"
                  title="Imprimir todos los PDFs"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="30"
                    height="30"
                    fill="currentColor"
                    className="bi bi-filetype-pdf"
                    viewBox="0 0 16 16"
                  >
                    <path fillRule="evenodd" d="M14 4.5V14a2 2 0 0 1-2 2h-1v-1h1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5L14 4.5ZM1.6 11.85H0v3.999h.791v-1.342h.803c.287 0 .531-.057.732-.173.203-.117.358-.275.463-.474a1.42 1.42 0 0 0 .161-.677c0-.25-.053-.476-.158-.677a1.176 1.176 0 0 0-.46-.477c-.2-.12-.443-.179-.732-.179Zm.545 1.333a.795.795 0 0 1-.085.38.574.574 0 0 1-.238.241.794.794 0 0 1-.375.082H.788V12.48h.66c.218 0 .389.06.512.181.123.122.185.296.185.522Zm1.217-1.333v3.999h1.46c.401 0 .734-.08.998-.237a1.45 1.45 0 0 0 .595-.689c.13-.3.196-.662.196-1.084 0-.42-.065-.778-.196-1.075a1.426 1.426 0 0 0-.589-.68c-.264-.156-.599-.234-1.005-.234H3.362Zm.791.645h.563c.248 0 .45.05.609.152a.89.89 0 0 1 .354.454c.079.201.118.452.118.753a2.3 2.3 0 0 1-.068.592 1.14 1.14 0 0 1-.196.422.8.8 0 0 1-.334.252 1.298 1.298 0 0 1-.483.082h-.563v-2.707Zm3.743 1.763v1.591h-.79V11.85h2.548v.653H7.896v1.117h1.606v.638H7.896Z"/>
                  </svg>
                  <span className="ms-2">Imprimir Todos</span>
                </button>
              </div>
            </div>
          </div>

          <ModalRegistro
            show={show}
            tabla={tablaF}
            setShow={setShow}
            handleClose={handleClose}
          />
          <Grid
            data={tabla}
            resizable={true}
            columns={[
              {
                id: "id_lider",
                name: "#",
                width: "5%",
              },
              {
                id: "cedulaLider",
                name: "Cedula",
                width: "10%",
              },
              {
                id: "nombreLider",
                name: "Nombre",
              },

              {
                id: "apellidoLider",
                name: "Apellido",
              },
              {
                id: "telefonoLider",
                name: "Telefono",
              },

              {
                id: "total_registros",
                name: "Personas acargo",
                width: "15%"
              },
              {
                name: "Actions",
                width: "10%",
                formatter: (cell, row) =>
                  _(
                    <div
                      className="btn-group"
                      role="group"
                      aria-label="Basic example"
                    >
                      <button
                        className={"btn btn-danger"}
                        title="Eliminar"
                        onClick={() => Deletelink(row.cells[0].data)}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          className="bi bi-person-dash-fill"
                          viewBox="0 0 16 16"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M11 7.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5z"
                          />
                          <path d="M1 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H1zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z" />
                        </svg>
                      </button>

                      <button
                        className={"btn btn-primary"}
                        title="ver votantes"
                        onClick={() =>
                          History(`/lider/votantes/${`${row.cells[0].data}`}`)
                        }
                        
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          class="bi bi-binoculars"
                          viewBox="0 0 16 16"
                        >
                          <path d="M3 2.5A1.5 1.5 0 0 1 4.5 1h1A1.5 1.5 0 0 1 7 2.5V5h2V2.5A1.5 1.5 0 0 1 10.5 1h1A1.5 1.5 0 0 1 13 2.5v2.382a.5.5 0 0 0 .276.447l.895.447A1.5 1.5 0 0 1 15 7.118V14.5a1.5 1.5 0 0 1-1.5 1.5h-3A1.5 1.5 0 0 1 9 14.5v-3a.5.5 0 0 1 .146-.354l.854-.853V9.5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v.793l.854.853A.5.5 0 0 1 7 11.5v3A1.5 1.5 0 0 1 5.5 16h-3A1.5 1.5 0 0 1 1 14.5V7.118a1.5 1.5 0 0 1 .83-1.342l.894-.447A.5.5 0 0 0 3 4.882V2.5zM4.5 2a.5.5 0 0 0-.5.5V3h2v-.5a.5.5 0 0 0-.5-.5h-1zM6 4H4v.882a1.5 1.5 0 0 1-.83 1.342l-.894.447A.5.5 0 0 0 2 7.118V13h4v-1.293l-.854-.853A.5.5 0 0 1 5 10.5v-1A1.5 1.5 0 0 1 6.5 8h3A1.5 1.5 0 0 1 11 9.5v1a.5.5 0 0 1-.146.354l-.854.853V13h4V7.118a.5.5 0 0 0-.276-.447l-.895-.447A1.5 1.5 0 0 1 12 4.882V4h-2v1.5a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5V4zm4-1h2v-.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5V3zm4 11h-4v.5a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5V14zm-8 0H2v.5a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5V14z" />
                        </svg>
                       
                      </button>
                      <a className={"btn btn-secondary"} target="_blank" rel="noopener noreferrer" href={`${process.env.REACT_APP_SERVER_URL}/reportes/index.php?id=${row.cells[0].data}`}>
                      <svg xmlns="http://www.w3.org/2000/svg" 
                    width="16" 
                    height="16" fill="currentColor" className="bi bi-filetype-pdf" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M14 4.5V14a2 2 0 0 1-2 2h-1v-1h1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5L14 4.5ZM1.6 11.85H0v3.999h.791v-1.342h.803c.287 0 .531-.057.732-.173.203-.117.358-.275.463-.474a1.42 1.42 0 0 0 .161-.677c0-.25-.053-.476-.158-.677a1.176 1.176 0 0 0-.46-.477c-.2-.12-.443-.179-.732-.179Zm.545 1.333a.795.795 0 0 1-.085.38.574.574 0 0 1-.238.241.794.794 0 0 1-.375.082H.788V12.48h.66c.218 0 .389.06.512.181.123.122.185.296.185.522Zm1.217-1.333v3.999h1.46c.401 0 .734-.08.998-.237a1.45 1.45 0 0 0 .595-.689c.13-.3.196-.662.196-1.084 0-.42-.065-.778-.196-1.075a1.426 1.426 0 0 0-.589-.68c-.264-.156-.599-.234-1.005-.234H3.362Zm.791.645h.563c.248 0 .45.05.609.152a.89.89 0 0 1 .354.454c.079.201.118.452.118.753a2.3 2.3 0 0 1-.068.592 1.14 1.14 0 0 1-.196.422.8.8 0 0 1-.334.252 1.298 1.298 0 0 1-.483.082h-.563v-2.707Zm3.743 1.763v1.591h-.79V11.85h2.548v.653H7.896v1.117h1.606v.638H7.896Z"/>
</svg>
                      </a>
                     

                
                       
                     
                      
                    </div>
                  ),
              },
            ]}
            search={true}
            pagination={{
              enabled: true,
              limit: 7,
            }}
          />
        </>
      )}
    </div>
  );
};
export default Lider;
